<template>
  <div class="wrapper">
    <p style="color: #666">更新日期：2024年1月1日</p>
    <p style="color: #666">生效日期：2024年1月1日</p>
    <p>
      【<b>特别提示</b>】
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </p>
    <p>
      1.请在使用本产品（或服务）前，仔细阅读并了解《隐私权政策》（以下简称“本隐私权政策”，尤其是加粗或划线的内容。<b>在确认充分理解并同意后使用我们的产品或服务。一旦您开始使用本公司的产品和服务，即表示您已充分理解并同意本政策，并同意我们按照本隐私政策收集、使用、储存和分享您的相关信息。</b>阅读过程中，如您有任何疑问，可通过电话或电邮方式获得帮助。一旦您点击“同意”本隐私权政策，我们将视为您充分理解并同意本隐私权政策。
    </p>
    <p>
      2.【郑州云济信息科技有限公司】（以下简称“我们”“本公司”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
    </p>
    <p>
      3.为了向您提供优质服务，主要需要获取以下权限和信息。系统将弹框提示，建议您允许获取相关权限：
    </p>
    <p>获取计算机信息权限。</p>
    <p>当您登录本软件时，我们会收集计算机信息用于硬件绑定。</p>
    <p>
      获取启用存储读取权限。用于使用本软件服务中，将浏览图片或者文字信息保存至计算机存储中。如您拒绝授权，您将无法保存图片或者文字信息，但不影响您正常使用其他功能。
    </p>
    <p>其他功能。</p>
    <p>
      4.使用本软件服务过程中，还将可能使用其他权限，详见本软件服务隐私政策。
    </p>
    <p><!--[if-->5.&nbsp;<!--[endif]-->本隐私权政策将帮助您了解以下内容：</p>
    <p>• 本协议的适用范围</p>
    <p>• 我们如何收集和使用您的个人信息</p>
    <p>• 我们如何使用Cookie和同类技术</p>
    <p>• 我们如何共享、转让、公开披露您的个人信息</p>
    <p>• 我们如何保护和保存您的个人信息</p>
    <p>• 您的权利</p>
    <p>• 我们如何处理未成年人的信息</p>
    <p>• 本隐私权政策如何更新</p>
    <p>• 您如何与我们取得联系</p>
    <p><b>条款正文</b><b></b></p>
    <p><b>一、本协议的使用范围</b><b></b></p>
    <p>
      （一）本隐私权政策适用于显示本隐私政策、或链接至本隐私政策的网站和产品、服务。服务包括向您提供页面浏览、小程序登录服务，以及通过云济公司向您提供的产品服务。但本政策可能并不涉及所有可能的数据处理情境。有关收集产品或服务特定数据的信息可能由云济公司在补充政策中，或者在收集数据时提供的通知中发布。
    </p>
    <p>
      （二）本隐私权政策不适用于其他第三方向您提供的服务。例如，云济公司平台上的服务商依托云济公司平台向您提供服务时，您向服务商提供的信息不适用本隐私权政策。我们对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容和服务。我们无法控制第三方的隐私和数据保护政策，此类第三方不受到本政策的约束。在向第三方提交个人信息之前，请参见这些第三方的隐私保护政策。
    </p>
    <p>
      （三）需要特别说明的是，本《隐私权政策》为统一适用的一般性隐私条款，本政策所述之“我们的产品与/或服务”以及我们收集的您个人信息的类型和对应的使用、处理规则等可能会因您使用的具体的产品/服务而有所不同，具体以您实际使用的产品和/或服务为准。该产品或服务的单独隐私政策未涵盖的部分，以本隐私政策内容为准。
    </p>
    <p><b>二</b><b>、我们如何收集和使用您的个人信息</b><b></b></p>
    <p>
      您同意，在下列环节向我们提供下列信息，并授权我们识别、记录、保存并在为您提供服务时使用下列信息。同时您授权我们可在需要第三方配合为您提供服务的时候向该第三方提供必要的信息。
    </p>
    <p><b>（一）注册成为用户</b><b></b></p>
    <p>在创建账号时，</p>
    <p>
      您至少需要向我们提供以下信息：您的姓名、您本人的手机号码、个人常用设备信息、计算机号、电子邮箱地址、用户名和密码。若您进行法人认证时，您至少需要向我们提供您的法定代表人姓名、法定代表人身份证号、企业名称、企业社会统一信用代码证。如果您在用户注册时不提供上述信息，您将无法享受我们提供的产品与/或服务。
    </p>
    <p>
      在注册过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：工作职位、公司。因产品服务与实际使用相关联，若用户提供的信息不完整、不真实，则可能在使用过程中受限或无法使用部分功能。
    </p>
    <p><b>（二）页面内容展示</b><b></b></p>
    <p>
      除法律另有规定之外，我们将您本人提供给本软件的信息、因享受本软件服务而产生的信息（包括本协议签署之前提供和产生的信息）及之本软件根据本条约定查询、收集的信息，用于本软件及因服务必要而委托的合作伙伴为用户本人提供服务、推荐产品、开展市场调查与信息数据分析。
    </p>
    <p>
      在使用软件的过程中，我们可能会收集和处理有关您的计算机信息、位置信息、网络身份标识信息，以使得您不需要手动输入自身地理坐标就可获得相关服务。我们会使用各种技术进行定位，这些技术包括IP地址等能够提供相关信息的其他传感器（比如可能会为我们提供附近设备、Wi-Fi
      接入点和基站的信息）。
    </p>
    <p><b>（三）商品的展示与购买</b><b></b></p>
    <p>1.虚拟商品的下单与支付</p>
    <p>
      &nbsp;付费类虚拟商品，包括但不限于课程、电子书、听书、付费直播、智能陪练、学习地图，需要您支付相应金额的货币下单并支付完成后使用，为实现付费类虚拟商品的下单功能，我们需要获取您的账号，下单完成后，您可选择使用本软件内的账户余额或与本公司合作的第三方支付机构所提供的支付服务，支付功能需收集您的账号，但我们需要将您的订单号和交易金额与这些支付机构共享以实现其确认您的支付指令并完成支付。
    </p>
    <p>2.商城功能的使用</p>
    <p>
      商城主要以实体商品的展示和销售为主，在您使用商城内的以下功能时，我们按照最少够用原则收集您的个人信息并用于相应功能的实现：
    </p>
    <p>（1）商品的展示、加购与搜索功能</p>
    <p>
      为保证您准确挑选您所需的商品或服务，我们在商城内为您提供商品展示、搜索及加入购物车的功能，为此我们会收集您的账号。
    </p>
    <p>（2）商品的购买</p>
    <p>
      当您下单您选购的商品或服务时，系统会生成您购买该商品或服务的订单，我们会收集您的账号，您还需要在订单中填写您的收件人姓名、电话号码、收货地址，如您需要开具发票，您还需提供发票抬头、税号以及用于接收发票的手机号或邮箱。
    </p>
    <p>
      下单完成后，您可选择使用本软件内的账户余额或与本公司合作的第三方支付机构所提供的支付服务，支付功能需收集您的账号，但我们需要将您的订单号和交易金额与这些支付机构共享以实现其确认您的支付指令并完成支付。
    </p>
    <p>（3）商品的交付</p>
    <p>
      在当您下单并在线完成支付后，与合作的第三方配送公司将为您完成订单的交付。您知晓并同意与本公司合作的第三方配送公司会在上述环节内使用您的订单信息以保证您的订购的商品能够安全送达。
    </p>
    <p>3.订单管理功能</p>
    <p>
      为便于您了解查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。
    </p>
    <p><b>（</b><b>四</b><b>）考试</b><b></b></p>
    <p>1. 考前实名认证</p>
    <p>
      管理员发布实名认证的考试时，需在用户进入考试前进行实名认证，确保参考人员、身份证信息与账号是同一个人。该情况下，用户必须同意获取相机和相册权限方可完成人脸识别、拍摄或从相册中获取身份证件照片上传，如拒绝，则会导致因无法获取人脸信息与身份证图片信息，无法完成实名认证与进入考试。
    </p>
    <p>2. 人脸识别监考</p>
    <p>
      管理员发布考试时，可以选择人脸识别校验的监考模式，确保考试人员与账号是同一个人。该情况下，用户必须同意获取相机权限方可完成监考考试，如拒绝，则会导致因无法获取考试人员的人脸信息，无法正常进入考试。
    </p>
    <p>3. 答案上传附件</p>
    <p>
      考试中包含复杂公式的主观题，支持用户上传附件为图片格式的答案。图片格式，需要获取相机和相册权限，以便拍摄或从相册中获取合适的图片内容。
    </p>
    <p>4. 考试功能使用</p>
    <p>
      为保证用户能正常参与平台内的各项考试，提交答案，获取考试成绩等个人相关数据，为此我们会收集用户的账号。
    </p>
    <p><b>（</b><b>五</b><b>）问卷功能</b><b></b></p>
    <p>
      为保证用户能正常参与平台内的各项问卷调研，提交问卷结果，为此我们会收集用户的账号。
    </p>
    <p><b>（</b><b>六</b><b>）学习全景图/学习地图</b><b></b></p>
    <p>
      为保证用户能正常使用平台的学习全景图/学习地图功能，完成此功能中相关资源学习，记录用户学习状态，为此我们会收集用户的账号。
    </p>
    <p><b>（</b><b>七</b><b>）直播</b><b></b></p>
    <p>
      为保证直播的连麦、开播的正常进行，我们会取得用相机和麦克风的权限；当用户进行预约直播时，我们将写入用户的日历数据；部分用户报告故障后，我们会读取系统底层日志；基于数据分析以及安全考虑，在用户的允许情况下，我们会读取用户的定位信息。
    </p>
    <p><b>（</b><b>八</b><b>）小视频</b><b></b></p>
    <p>为保证小视频的录制正常进行，我们会取得用相机、麦克风的权限。</p>
    <p><b>（</b><b>九</b><b>）智能陪练</b><b></b></p>
    <p>
      为保证用户能正常使用智能陪练功能，完成语音识别与微表情识别，我们会取得用相机、麦克风的权限。
    </p>
    <p><b>（十）学习计划与学习成就功能</b><b></b></p>
    <p>1.学习计划功能</p>
    <p>
      我们为您提供学习计划功能，您可默认使用我们为您制定的学习计划，也可根据您的自身情况和需求制定和调整您的学习计划，为此，我们需要获取您的账号、软件使用情况，您也可以选择不使用此项功能，如您不使用此项功能，我们则不会为实现此项功能获取您的个人信息。
    </p>
    <p>2.学习成就功能</p>
    <p>
      我们为您提供学习成就功能，记录您的学习数据以为您授予勋章、证书，并形成您的学习积分，为此，我们需要获取您的账号、软件使用记录以实现前述功能。
    </p>
    <p><b>（十</b><b>一</b><b>）</b><b>发帖</b><b></b></p>
    <p>为保证用户能发帖、回帖中添加图片，我们会取得相机与相册的权限。</p>
    <p>
      当您与我们联系或提出售中售后、争议纠纷处理申请时，为了保障您的帐号安全，我们需要您提供必要的个人信息以核验您的用户身份。
    </p>
    <p>
      为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的通信/通话记录及相关内容（包括帐号信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的帐号信息和订单信息。
    </p>
    <p>
      为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息。
    </p>
    <p><b>（十</b><b>二</b><b>）保障交易安全</b><b></b></p>
    <p>
      为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或相关协议规则的情况，我们可能使用或整合您的账号信息、交易信息、设备信息、软件使用记录、点击记录以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合识别您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
    </p>
    <p><b>（十</b><b>三</b><b>）虚拟商品在线使用</b><b></b></p>
    <p>
      虚拟商品，包括课程、听书、电子书、直播、智能陪练及学习地图，我们为您提供了在线使用功能（每一个具体虚拟商品的在线使用功能可能略有不同，以网页上显示的功能为准），您可以在相应的界面中进行评论、留言、转发、记笔记，也可以进行收藏、下载、分享以及购买后赠送，为此，我们需要收集您的账号、软件使用记录以实现前述功能。
    </p>
    <p>
      请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地共享甚至公开分享相关信息。
    </p>
    <p><b>（十</b><b>四</b><b>）客服与售后功能</b><b></b></p>
    <p>
      当您与我们联系或提出售中售后、争议纠纷处理申请时，为了保障您的帐号安全，我们需要您提供必要的个人信息以核验您的用户身份。
    </p>
    <p>
      为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的通信/通话记录及相关内容（包括帐号信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的帐号信息和订单信息。
    </p>
    <p>
      为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息。
    </p>
    <p><b>（十</b><b>五</b><b>）为您提供其他附加功能</b><b></b></p>
    <p>
      <b
        >在您使用软件服务过程中，为了保证您能正常使用产品功能，我们仅会在使用期间基于最大必要性以及最小范围的原则收集您的一些信息，并向系统申请您的以下设备权限，申请前我们会征询您的同意，您可以选择“允许”或“禁止”权限申请；申请成功后，您可以随时进入计算机“设置-权限管理”中关闭相应权限，权限关闭后相关产品功能可能无法正常使</b
      ><b></b>
    </p>
    <p><b>这些附加服务包括：</b><b></b></p>
    <p>1.个性化内容服务</p>
    <p>
      我们会根据您的软件使用情况对您进行定制化的内容服务，例如为您推荐适合您的商品或服务等，为此，我们需要获取您的账号、软件使用记录。若您不同意使用个性化内容推荐，您可以将此功能关闭。
    </p>
    <p>2.数据统计与产品优化</p>
    <p>
      为了通过数据统计对产品进行优化，我们只在每次启动时收集一次您的设备MAC地址，唯一设备识别码、广告追踪标识符（IDFA）、账号、性别、出生年份、学历、行业、职业、软件使用记录、点击记录、IP地址。
    </p>
    <p>3.基于相机、相册权限的附加服务</p>
    <p>
      您可以在开启相机、相册权限后使用该功能，以实现头像上传、意见反馈、获取人脸信息。
    </p>
    <p>4.基于麦克风权限的附加服务</p>
    <p>
      我们仅在讲师使用直播过程中，通过开启麦克风权限以实现在在线直播界面发送语音进行交流、答疑，学员可以进行连麦与讲师进行语音交流，可以使用语音转文字功能，减少手动输入操作，提升体验。
    </p>
    <p>5.基于位置定位的附加功能</p>
    <p>
      我们仅在您使用面授班扫码地理位置签到功能时，向您的计算机系统申请“位置权限”。
    </p>
    <p>6. 基于获取设备信息权限的附加功能</p>
    <p>
      为了您的账号安全，我们只在每次启动时收集一次您的硬件设备信息，并与系统上的设备信息进行匹配，从而评估您的账号登录是否存在风险。在此过程中，我们会向系统申请“获取设备信息权限”。
    </p>
    <p>
      为了给您提供更优质的服务，我们可能会根据产品功能向系统申请您的其他设备权限，如果您拒绝开启相应设备权限，您可以随时进入计算机“设置-权限管理”中关闭相应权限，权限关闭后相关产品功能可能无法正常使用，请您理解。
    </p>
    <p><b>（十</b><b>六</b><b>）与您沟通</b><b></b></p>
    <p>
      我们会利用收集的信息（例如您的计算机号码、电子邮件地址）直接与您沟通或互动。例如，如果我们检测到账号异常登录活动。
    </p>
    <p><b>（十</b><b>七</b><b>）改善和运营本产品和服务</b><b></b></p>
    <p>
      我们使用收集的信息来提供并改进我们及关联方、合作方提供的产品和服务，并进行必要的业务运营，例如运营产品或提供服务，评估、维护和改进产品和服务的性能，开发新的产品和服务、提供客户支持等。
    </p>
    <p>
      为改进我们及关联方、合作方的产品和服务，我们也可能会对产品使用情况进行统计和分析。同时，可能会与关联方、合作方、公众共享这些统计信息，以展示我们服务的整体使用趋势，但这些统计信息将不会包含您的任何身份识别信息。
    </p>
    <p><b>（十</b><b>八</b><b>）</b><b>您个人信息使用的规则</b><b></b></p>
    <p>
      1.我们会根据本隐私政策的规定，为实现我们的产品与/或服务功能而对所收集的个人信息进行使用。
    </p>
    <p>
      2.在收集您的个人信息后，我们将通过技术手段对信息进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据进行分析并予以利用。
    </p>
    <p>
      3.请您了解并统一，对于您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将被视为您在使用的产品与/或服务期间持续授权同意我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。
    </p>
    <p>
      4.我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
    </p>
    <p>
      5.当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。
    </p>
    <p>
      6.当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的个人信息用于其他目的时，会事先征求您的明示同意。如果您选择使用本隐私政策中尚未列明的其他产品与/或服务时，我们会在收集您的个人信息前通过协议、页面提示等方式向您详细说明信息收集的目的、方式、范围并征求您的同意。若您不同意提供前述信息，您可能无法使用该项产品与/或服务，但不影响您使用现有产品与/或服务。
    </p>
    <p><b>二、我们如何使用 Cookie 和同类技术</b><b></b></p>
    <p><b>（一）Cookie</b><b></b></p>
    <p>
      为确保网站正常运转，我们会在您的计算机上存储名为 Cookie
      的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。
    </p>
    <p>
      我们不会将 Cookie
      用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。
    </p>
    <p><b>（二）网站信标和像素标签</b><b></b></p>
    <p>
      除Cookie外，我们还会在网站上使用网站信标和像素标签其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
    </p>
    <p><b>三、我们如何共享、转让、公开披露您的个人信息</b><b></b></p>
    <p><b>（一）共享</b><b></b></p>
    <p>
      <b
        >您确认，您授权本公司，除法律另有规定之外，将您提供给本公司的信息、享受本公司服务产生的信息（包括本条款签署之前提供和产生的信息）以及本公司根据本条款约定查询、收集的信息，用于本公司及其因服务必要委托的合作伙伴为您提供服务、推荐产品、开展市场调查与信息数据分析</b
      ><b
        >，包括但不限于使用用户提供的信息，通过人社数据指定端口查询用户社保数据用于数据比对等</b
      ><b
        >。您授权本公司，除法律另有规定之外，基于为您提供更优质服务和产品的目的，向本公司因服务必要开展合作的伙伴提供、查询、收集您的信息。</b
      >前述“信息”可能包括但不限于您的身份信息、账户信息、信用信息、交易信息、计算机信息、计算机操作日志及其他与您相关的信息。
    </p>
    <p>我们向合作伙伴共享您个人信息的情形如下：</p>
    <img
      style="width: 100%"
      src="data:image/png;base64,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"
    />
    <p>
      为确保您信息的安全，本公司对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。本条款自您签署时生效，具有独立法律效力，不受本条款所属合同或协议成立与否及效力状态变化的影响。
    </p>
    <p><b>（二）转让</b><b></b></p>
    <p>
      我们不会将您的个人信息转让给除关联方外的任何公司、组织和个人，但以下情况除外：
    </p>
    <p>
      <b
        >1.在事先获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息</b
      >。
    </p>
    <p>
      <b>2.满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；</b><b></b>
    </p>
    <p>
      <b>3</b>.<b
        >在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</b
      ><b></b>
    </p>
    <p><b>（三）公开披露</b><b></b></p>
    <p>
      原则上我们不会将您的信息进行公开披露。如确需公开披露，我们会向您告知公开披露的目的，披露信息的类型以及可能涉及的敏感信息，并征得您明确同意。
    </p>
    <p>
      根据相关法律法规和国家标准，<b>在以下情形中，我们可能会依法共享、转让、公开披露您的个人信息而无需征得您的同意</b>：
    </p>
    <p><b>1.与国家安全、国防安全直接相关的；</b><b></b></p>
    <p><b>2.与公共安全、公共卫生、重大公共利益直接相关的；</b><b></b></p>
    <p><b>3.与犯罪侦查、起诉、审判和判决执行等直接相关的；</b><b></b></p>
    <p>
      <b
        >4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</b
      ><b></b>
    </p>
    <p><b>5.您自行向社会公众公开的个人信息；</b><b></b></p>
    <p>
      <b
        >6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</b
      ><b></b>
    </p>
    <p><b>7.根据个人信息主体要求签订和履行合同所必需的；</b><b></b></p>
    <p><b>8.用于维护所提供的服务的安全稳定运行所必须的。</b><b></b></p>
    <p>
      根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
    </p>
    <p><b>四、我们如何保护和保存您的个人信息</b><b></b></p>
    <p><b>（一）保存期限</b><b></b></p>
    <p>
      <b>您在使用本产品及服务期间，我们将持续为您保存您的个人信息</b
      >。如果您注销帐户或主动删除上述信息，我们将依据网络安全法等法律法规规定保存您的信息。在您注销帐户或主动删除上述信息后，我们不会再对您的个人信息进行商业化使用，但我们可能会对您的个人信息进行匿名化处理后使用。
    </p>
    <p><b>（二）保存地域</b><b></b></p>
    <p>
      您的个人信息均储存于中华人民共和国境内。如部分产品或服务涉及跨境，我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。
    </p>
    <p><b>（三）安全措施</b><b></b></p>
    <p>
      1.我们会以业界成熟的安全标准和规范收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。
    </p>
    <p>
      2.我们非常重视信息安全。我们委派了专责团队负责研发和应用多种安全技术和程序等，我们会对安全管理负责人和关键安全岗位的人员进行安全背景审查，我们建立了完善的信息安全管理制度和内部安全事件处置机制等。我们会采取符合业界标准的合理可行的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、修改、毁损、丢失或泄漏。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。
    </p>
    <p>
      3.我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们部署访问控制机制，对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工、合作伙伴签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。若有违反保密协议的行为，会被追究相关责任。
    </p>
    <p>
      4.在个人信息安全事件时，我们会立即启动应急预案，采取相应的补救措施，在最短时间内追溯原因并减少损失。与此同时，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
    </p>
    <p>
      5.<b>我们提醒您注意，互联网并非绝对安全的环境，请注意确保您个人信息的安全，请使用复杂密码，协助我们保证您的账号以及个人信息安全</b>。
    </p>
    <p><b>五、您的权利</b><b></b></p>
    <p>
      按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
    </p>
    <p><b>（一）访问您的个人信息</b><b></b></p>
    <p>
      您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
    </p>
    <p>
      账户信息——如果您希望访问或编辑您的账户中的个人资料信息和支付信息、更改您的密码，您可以通过“我的”页面进行编辑和修改。
    </p>
    <p>如果您希望关闭您的账户，您可以自行注销帐号。</p>
    <p>
      对于您在使用我们的产品或服务过程中产生的您的个人信息，只要我们不需要过多投入，我们可根据您的申请向您提供。
    </p>
    <p><b>（二）更正您的个人信息</b><b></b></p>
    <p>
      当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。
    </p>
    <p>
      如果您无法通过上述链接更正这些个人信息，您可以随时致电客服热线<b>0371</b
      ><b>-56923639</b>，我们将在30天内回复您的更正请求。
    </p>
    <p><b>（三）删除您的个人信息</b><b></b></p>
    <p>您可以随时向我们提出删除个人信息的请求。</p>
    <p>
      若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
    </p>
    <p>
      当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
    </p>
    <p><b>（四）改变您授权同意的范围</b><b></b></p>
    <p>
      每个业务功能需要一些基本的个人信息才能得以完成（见本策略“第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时关闭相应权限。
    </p>
    <p>
      当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
    </p>
    <p>
      如果您不想接受我们给您发送的商业广告，您可以随时致电客服热线<b>0371</b
      ><b>-56923639</b>，我们将在15天内回复您的更正请求。
    </p>
    <p><b>（五）个人信息主体注销账户</b><b></b></p>
    <p>
      您随时可注销此前注册的账户，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。
    </p>
    <p><b>（六）个人信息主体获取个人信息副本</b><b></b></p>
    <p>
      在技术可行的前提下，例如数据接口匹配，我们还可按您的要求，直接将您的个人信息副本传输给您。
    </p>
    <p><b>（七）约束信息系统自动决策</b><b></b></p>
    <p>
      在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，或要求我们关闭对您的自动决策机制。
    </p>
    <p><b>（八）响应您的上述请求</b><b></b></p>
    <p>
      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
    </p>
    <p>我们将在15日内答复。如您不满意，还可以通过以下途径投诉：</p>
    <p>• 人工服务电话：0371-56923639</p>
    <p>• 服务邮箱：yunji@yun-g.com</p>
    <p>我们将会在收到您投诉之后的十五日内答复及处理。</p>
    <p>
      对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁盘上存放的信息）的请求，我们可能会予以拒绝。
    </p>
    <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
    <p>1.与国家安全、国防安全有关的；</p>
    <p>2.与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3.与犯罪侦查、起诉和审判和执行等有关的；</p>
    <p>4.有充分证据表明您存在主观恶意或滥用权利的；</p>
    <p>5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
    <p><b>六、我们如何处理未成年的个人信息</b><b></b></p>
    <p>
      我们的产品、网站和服务只面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。
    </p>
    <p>
      对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关内容。
    </p>
    <p>
      尽管当地法律和习俗对儿童的定义不同，但我们将不满18周岁的任何人均视为非成年人。对于经父母或监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。如果我们发现自己在未事先获得可证实的父母或监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
    </p>
    <p><b>七、本隐私权政策如何更新</b><b></b></p>
    <p>
      <b
        >我们可能适时会对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以推送消息的方式公布，并且标注更新时间。除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的1日后生效。如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示的方式通知您。在该种情况下，如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、理解并接受修改后的隐私权政策并受其约束</b
      >。
    </p>
    <p>
      对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
    </p>
    <p>本政策所指的重大变更包括但不限于：</p>
    <p>
      （一）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
    </p>
    <p>
      （二）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
    </p>
    <p>（三）个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>（四）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>
      （五）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
    </p>
    <p>（六）个人信息安全影响评估报告表明存在高风险时。</p>
    <p><b>八、如何联系我们</b><b></b></p>
    <p>
      如果您对本隐私政策有任何疑问、意见或建议，可致电客服热线0371-56923639。
    </p>
    <p>名词解释：</p>
    <p>
      <b>个人信息</b
      >是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息包括：基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、驾驶证、社保信息等）；个人生物识别信息（包括声纹、面部识别特征等）；网络身份标识信息（包括个人信息主体账号、IP地址、个人数字证书等）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码）；个人位置信息（包括行程信息、精准定位信息）。
    </p>
    <p>
      <b>设备</b>是指可用于产品和/或服务的装置，例如桌面设备、平板电脑或计算机。
    </p>
    <p>
      <b>Cookie</b
      >是指支持服务器端（或者脚本）在客户端上存储和检索信息的一种机制，通过增加简单、持续的客户端状态来扩展基于Web的客户端/服务器应用。服务器在向客户端返回HTTP对象的同时发送一条状态信息，并由客户端保存。状态信息中说明了该状态下有效的URL范围。此后，客户端发起的该范围内的HTTP请求都将把该状态信息的当前值从客户端返回给服务器，这个状态信息被称为Cookie。
    </p>
    <p>
      <b>匿名标示符</b
      >是指本公司基于设备参数，通过机器算法，生成一个标示符例如BAIDUID、CUID，帮助我们识别一个用户，为其提供更好的产品和/或服务与改善用户体验。
    </p>
    <p>
      <b>用户画像</b
      >是指通过收集、汇聚、分析个人信息，对某特定自然人个人特征，如其职业、经济、健康、教育、个人喜好、信用、行为等方面做出分析或预测，形成其个人特征模型的过程。直接使用特定自然人的个人信息，形成该自然人的特征模型，称为直接用户画像。使用来源于特定自然人以外的个人信息，如其所在群体的数据，形成该自然人的特征模型，称为间接用户画像。
    </p>
    <p>
      <b>匿名化</b
      >是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。
    </p>
    <p>
      <b>本软件</b
      >是指郑州云济信息科技有限公司本软件平台及网站、程序、服务、工具及客户端。
    </p>
    <p>
      <b>关联公司</b
      >是指“本软件”的经营者郑州云济信息科技有限公司及其他与本公司存在关联关系的公司的单称或合称。“关联关系”是指对于任何主体（包括个人、公司、合伙企业、组织或其他任何实体）而言，即其直接或间接控制的主体，或直接或间接控制其的主体，或直接或间接与其受同一主体控制的主体。前述“控制”指，通过持有表决权、合约或其他方式，直接或间接地拥有对相关主体的管理和决策作出指示或责成他人作出指示的权力或事实上构成实际控制的其他关系。
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  overflow-y: scroll;
  padding: 0 0.3rem;
  height: 400px;
}
</style>